export default "__VITE_ASSET__CkevNQ9E__"